const colorsList = [
    'primary',
    'success',
    'warning',
    'error',
    'info',
    'caution',
    'indigo',
    'typography',
    'background',
];
const colorTones = [0, 30, 50, 80, 90, 100, -10, 'light', 'dark'];
export const colorsPrefix = '--wf-colors';
export const hexToRGBCode = (hexCode) => {
    let hex = hexCode.replace('#', '');
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hexCode)) {
        if (hex.length === 3) {
            hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
        }
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return [r, g, b];
    }
    return [];
};
export const darkenRGB = (rgbArray, factor) => {
    if (factor < 0 || factor > 100) {
        return rgbArray;
    }
    return rgbArray.map((item) => Math.floor(item * (1 - factor / 100)));
};
export const lightenRGB = (rgbArray, factor) => {
    if (factor < 0 || factor > 100) {
        return rgbArray;
    }
    return rgbArray.map((item) => Math.floor(item + (255 - item) * (factor / 100)));
};
export const recogniseType = (tone) => {
    let type = '';
    if (+tone && +tone < 0) {
        type = `-darken-${0 - Number(tone)}`;
    }
    else if (+tone && +tone > 0) {
        type = `-lighten-${tone}`;
    }
    else if (tone === 'light' || tone === 'dark') {
        type = `-${tone}`;
    }
    return type;
};
const createPalette = () => {
    if (typeof window !== 'undefined') {
        const style = getComputedStyle(document.body);
        const collectedPalette = {};
        colorsList.forEach((eachColor) => {
            colorTones.forEach((eachTone) => {
                const type = recogniseType(eachTone);
                const colorName = `${colorsPrefix}-${eachColor}${type}`;
                const color = style.getPropertyValue(colorName);
                if (color) {
                    collectedPalette[`${eachColor}${type}`] = color.trimLeft();
                }
            });
        });
        return collectedPalette;
    }
    return {};
};
let palette = createPalette();
export const updatePalette = (colorTheme) => {
    if (document && colorTheme) {
        Object.keys(colorTheme).forEach((colorName) => {
            const rgbCode = hexToRGBCode(colorTheme[colorName]);
            if (rgbCode.length) {
                const { style } = document.documentElement;
                style.setProperty(`${colorsPrefix}-${colorName}`, `rgb(${rgbCode.toString()})`);
                style.setProperty(`${colorsPrefix}-${colorName}-lighten-30`, `rgb(${lightenRGB(rgbCode, 15).toString()})`);
                style.setProperty(`${colorsPrefix}-${colorName}-lighten-50`, `rgb(${lightenRGB(rgbCode, 46).toString()})`);
                style.setProperty(`${colorsPrefix}-${colorName}-lighten-80`, `rgb(${lightenRGB(rgbCode, 76).toString()})`);
                style.setProperty(`${colorsPrefix}-${colorName}-lighten-90`, `rgb(${lightenRGB(rgbCode, 90).toString()})`);
                style.setProperty(`${colorsPrefix}-${colorName}-darken-10`, `rgb(${darkenRGB(rgbCode, 20).toString()})`);
            }
        });
    }
    palette = createPalette();
};
export const getColorPalette = () => palette;
// example of usage => color(primary):--wf-colors-primary, color(primary, 30), color(primary, -10):--wf-colors-primary-darken-10
export const color = (name, tone = 0) => {
    const type = recogniseType(tone);
    const colorName = `${name}${type}`;
    const color = palette[colorName];
    if (!color && process.env.NODE_ENV !== 'test') {
        console.log(`%c Color "${name}" with tone "${tone} is not present in palete"`, 'font-weight: bold; color: red');
    }
    return `var(${colorsPrefix}-${colorName})`;
};
// example of usage => isColorFromPalette(primary):true, color(primary, -10):true, color(blabla, 30):false
export const isColorFromPalette = (color, tone = 0) => {
    const type = recogniseType(tone);
    const colorName = `${color}${type}`;
    return Boolean(palette[colorName]);
};
export const isColorDark = (color) => {
    let rgb;
    if (typeof color === 'string') {
        if (color.indexOf('#') !== -1) {
            rgb = color
                .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
                .substring(1)
                .match(/.{2}/g)
                .map((x) => parseInt(x, 16));
        }
        else if (color.indexOf('(') !== -1) {
            rgb = color
                .replace(/\(|\)/g, '')
                .split(',')
                .map((digit) => parseInt(digit.trim(), 10));
        }
        else {
            throw new Error(`not valid color: ${color}`);
        }
    }
    else {
        rgb = color;
    }
    const [r, g, b] = rgb;
    return (r * 0.299 + g * 0.587 + b * 0.114) / 256 <= 0.46;
};
